import { IAppConfig } from '../interfaces/IAppConfig';

export interface IFeatureFlagFactory {
    (...path: string[]): string;
}

const upperCamelCaseRegex = /^[0-9A-Z][0-9A-Za-z:]+?$/;

export function createFeatureFlagFactory (
    appConfig: IAppConfig,
): IFeatureFlagFactory {
    return (...path: string[]): string => {
        if (
            !path.every((chunk: string): boolean => {
                return upperCamelCaseRegex.test(chunk);
            })
        ) {
            throw new Error(
                `Feature flag created using "${path.join(
                    ', ',
                )}" which is non-standard. Each feature in the path must be UpperCamelCase.`,
            );
        }

        return [appConfig.FEATURE_FLAG_PREFIX, ...path].join(':');
    };
}
